module.exports = __webpack_public_path__ + "img/dna.2948f273.svg";